import * as Sentry from '@sentry/browser';

export class SentryValueConverter {

  toView(value: string, err?: any) {

    try {

      let valueStr: string = value;

      if (valueStr.length) {

        if (err && err.details && err.details.originalError &&
          err.details.originalError.description) {
          valueStr += `. ERR DESCRIPTION: ${err.details.originalError.description}`;
        }

        Sentry.addBreadcrumb({
          category: 'data',
          message: valueStr,
          level: Sentry.Severity.Warning,
        });
        // Sentry.captureMessage(value);
      }

      if (err) {
        Sentry.captureException(err);
      }

      return true;

    } catch (error) {
      Sentry.captureException('Sentry exception...');
      Sentry.captureException(error);
      console.log(`Error in sentry value-converter: ${error}`);
    }
  }
}
